import React, { Component } from 'react';
//import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Button } from 'reactstrap';
import {
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption
} from 'reactstrap';
import { UncontrolledCarousel } from 'reactstrap';


const items = [
    {
        src: 'https://photo-cdn.icons8.com/assets/previews/366/2381eb7b-9609-495c-8142-e314e23ea7981x.jpg',
        altText: 'Slide 1',
        caption: 'Slide 1',
        header: 'Slide 1 Header'
    },
    {
        src: 'https://photo-cdn.icons8.com/assets/previews/5/cead184b-f338-4674-9b3e-5958262783b61x.jpg',
        altText: 'Slide 2',
        caption: 'Slide 2',
        header: 'Slide 2 Header'
    },
    {
        src: 'https://photo-cdn.icons8.com/assets/previews/389/d136d35c-0260-4ae6-97bb-cdf8243c687c1x.jpg',
        altText: 'Slide 3',
        caption: 'Slide 3',
        header: 'Slide 3 Header'
    }
];

//const Example = () => <UncontrolledCarousel items={items} />;

export class ContactUs extends Component {
    static displayName = "DISPLAY NAME";

    // https://stackoverflow.com/questions/46160461/how-do-you-set-the-document-title-in-react
    componentDidMount() {
        document.title = "Contact Us Page";
    }

    render() {
        return (
            <div>
                <h1>Contact Us Page!</h1>
                <style>
                    {
                        `.custom-size {
                            max-width: 100%;
                            height: 50px;
                            background: black;
                          }`
                    }
                </style>
                <div className="custom-size" >
                    <UncontrolledCarousel items={items} />
                </div>
                <Button color="danger">Danger!</Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ContactUs.js